export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5550.bc89765d.jpg";